<template>
	<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<Row :gutter="10" style="margin-bottom: 20px">
			<Col>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
						type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</Col>			
		</Row>
		<Row :gutter="10" style="margin-bottom: 20px">

			<Col style="padding-left: 10px;">
			<div class="input-group">
				<Select v-model="shop_id" style="width: 150px;" placeholder="渠道" @on-change="getList">
					<Option v-for="item in clientIdList" :value="item.id" :key="item.id">
						{{item.username }}-[{{item.id}}]
					</Option>
				</Select>
			</div>
			</Col>
			<Col style="padding-left: 10px;">
			<div class="input-group">
				<Select v-model="quotationAdvCity" placeholder="城市" style="width: 100px;" @on-change="getList">
					<Option v-for="item in cityList" :value="item.city" :key="item.city">
						{{ item.city}}
					</Option>
				</Select>
			</div>
			</Col>
			<Col style="padding-left: 10px;">
			<div class="input-group">
				<Select placeholder="汇总类型" v-model="groupByType" @on-change="getList">
					<Option value="1" :key="1">渠道汇总 </Option>
					<Option value="2" :key="2">渠道城市</Option>
				</Select>
			</div>
			</Col>
			<Col style="padding-left: 10px;">
			<Button @click="initSearch" type="primary" >重置</Button>
			</Col>
		</Row>
		<Table border :columns="columns" :data="costData"></Table>
		<div class="pager">
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getDayCostList
	} from "../../../api/finance";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		props: {
			cityList: Array,
			clientIdList: Array
		},
		data() {
			return {
				columns: [{
						title: "排名",
						key: "ranking",
						align: 'center'
					},
					{
						title: "渠道",
						key: "username",
						align: 'center'
					},
					{
						title: "城市",
						key: "city",
						align: 'center'
					},
					{
						title: "消耗",
						key: "quotation_money",
						align: 'center'
					},
					{
						title: "单价",
						key: "quotation_average_money",
						align: 'center'
					},
					{
						title: "数量",
						key: "form_nums",
						align: 'center'
					},
					{
						title: "实时余额",
						key: "balance",
						align: 'center'
					},
				],
				columnsCopy: [{
						title: "排名",
						key: "ranking",
						align: 'center'
					},
					{
						title: "渠道",
						key: "username",
						align: 'center'
					},
					{
						title: "城市",
						key: "city",
						align: 'center'
					},
					{
						title: "消耗",
						key: "quotation_money",
						align: 'center'
					},
					{
						title: "单价",
						key: "quotation_average_money",
						align: 'center'
					},
					{
						title: "数量",
						key: "form_nums",
						align: 'center'
					},
					{
						title: "实时余额",
						key: "balance",
						align: 'center'
					},
				],
				costData: [],
				order_type: 'desc',
				count: 0,
				page: 1,
				pageSize: 20,
				pageSizeOpts: [20, 50, 100, 500],
				shop_id:'',
				quotationAdvCity:'',
				timePeriod: '3',
				timePeriodDate: [],
				groupByType:"1"
				
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
			this.userDisplayTable();
		},
		watch: {
			groupByType(){
				this.userDisplayTable();
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.page = that.page;
				data.pageSize = that.pageSize;
				data.quotationAdvCity = that.quotationAdvCity;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				data.shop_id = that.shop_id;
				data.groupByType = that.groupByType;
				let res = await getDayCostList(that, data);
				that.costData = res.data.list;
				that.count = res.data.count;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			userDisplayTable() {
				if (this.groupByType == "1") { //此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter(col => col.key !== 'city')
				} else {
					this.columns = this.columnsCopy
				}
			},			
			initSearch(){
				let that = this;
				that.timePeriod = '3';
				that.timePeriodDate = [];
				that.shop_id = "";
				that.quotationAdvCity = "";
				that.groupByType = "1";
				that.getList();
			}
		},
	};
</script>

<style lang="less" scoped>
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
